module.exports = __webpack_public_path__ + "static/media/landing4.c1f332b9.svg";